import React from "react";
import "./styled.css";
import { FaWhatsapp  } from "react-icons/fa";

const BotonFlotante = () => {
  const chatId = "541162255399"; // El ID del chat de Facebook

const handleClick = () => {
    window.open(`https://api.whatsapp.com/send?phone=${chatId}&text=%C2%A1Hola!%20Quiero%20cotizar%20un%20seguro%20de%20Auto.%20Ingres%C3%A9%20desde%20la%20web`, "_blank");
};

  return (
    <div className="boton-flotante" onClick={handleClick}>
      <div className="icono-messenger">
        <FaWhatsapp  size={24} />
      </div>
    </div>
  );
};

export default BotonFlotante;
